import { AssignmentStatus } from '@/views/share-history/constants';

const mutations = {
  SET_HISTORY: (state, history) => {
    state.history = history;
  },

  SET_COLUMNS: (state, columns) => {
    state.columns = columns;
  },

  SET_REFRESH_DATE: (state, timestamp) => {
    state.lastRefreshDate = timestamp;
  },

  SET_CURRENT_PAGE: (state, currentPage) => {
    state.currentPage = currentPage;
  },

  CANCEL_ASSIGNMENTS: (state, { id, status }) => {
    state.history = state.history.map(item => {
      if (item.assignment_id === id && item.status === AssignmentStatus.INCOMPLETE) {
        return { ...item, status };
      }

      return item;
    });
  },

  SET_DATE_RANGE(state, dateRange) {
    state.dateRange = dateRange;
  },

  SET_SEARCH_KEYWORD: (state, keyword) => {
    state.searchKeyword = keyword;
  },

  SET_FILTER: (state, { key, value }) => {
    state.filters = { ...state.filters, [key]: value };
  },

  DELETE_FILTER: (state, key) => {
    const filters = { ...state.filters };
    delete filters[key];
    state.filters = filters;
  },

  RESET_FILTERS: state => {
    state.filters = {};
  },
};

export default mutations;
